// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2RHbL","cell":"ColumnAccessor_cell__1Hise","firstCellAccent":"ColumnAccessor_firstCellAccent__1Krzu"};